import UUIDBase from '../UUIDBase'
import User from '../user/User'

// DiscountCode mirrors the server discount_codes resource. A code is 9 digits,
// scoped to all locations or a set of locations, single-use.
export default class DiscountCode extends UUIDBase {
  static ENDPOINT = '/sales/discountcodes'

  code = ''
  appliesToAll = false
  locationIDs: string[] = []
  isUsed = false
  usedAt: string | null = null
  usedByUserID = ''
  usedBy?: User | null = null
  usedByOrderID = ''
  usedAtLocationID = '' // the store where the code was used
  addedByUserID = ''
  addedBy?: User | null = null

  static from(json: Record<string, unknown> | DiscountCode) {
    return Object.assign(new DiscountCode(), json)
  }

  // formatted groups the 9-digit code as 3-3-3 (e.g. 335-245-300).
  get formatted(): string {
    const c = (this.code || '').replace(/\D/g, '')
    return c.length === 9 ? `${c.slice(0, 3)}-${c.slice(3, 6)}-${c.slice(6, 9)}` : this.code
  }
}
